import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const FCFA_FORMAT = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "XAF",
  currencyDisplay: "code",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function formatFcfa(amount: number): string {
  return FCFA_FORMAT.format(amount);
}

const DATETIME_FORMAT = new Intl.DateTimeFormat("fr-FR", {
  dateStyle: "short",
  timeStyle: "short",
  timeZone: "Africa/Libreville",
});

export function formatDateTime(iso: string): string {
  return DATETIME_FORMAT.format(new Date(iso));
}